import React, { useContext } from 'react'
import RegisterOscContext from '../../context/RegisterContext'
import { ActuationAndPublic } from './OscFields/ActuationAndPublic'
import { ContactFields } from './OscFields/ContactFields'
import { GeneralDataFields } from './OscFields/GeneralDataFields'
import { LogoAndDescription } from './OscFields/LogoAndDescriptionFields'
import { StructOrganizationFields } from './OscFields/StructOrganizationFields'

export const OscForm = () => {

    const {step} = useContext(RegisterOscContext)

    return (
        <div className=''>
            <div className={`${step !== 1 && 'hidden'}`}>
                <GeneralDataFields/>
            </div>
            <div className={`${step !== 2 && 'hidden'}`}>
                <ContactFields/>
            </div>
            <div className={`${step !== 3 && 'hidden'}`}>
                <ActuationAndPublic/>
            </div>
            <div className={`${step !== 4 && 'hidden'}`}>
                <StructOrganizationFields />
            </div>
            <div className={`${step !== 5 && 'hidden'}`}>
                <LogoAndDescription />
            </div>
        </div>
    )
}


